import { Copyright } from "lucide-react"
import { useLang } from "../context/LangContext"
import { LegalPage } from "./LegalShared"

const CONTENT = {
  en: {
    title: "Copyright & Intellectual Property",
    updated: "Last updated: April 2026",
    intro: "uCloud360 (formerly known as CoSharks) is an original platform protected under United States copyright law. All rights related to its concept, architecture, design, development, and content are exclusively owned by Inteligentic Solutions LLC and Jean Paul Zerpa.",
    sections: [
      {
        h: "Copyright Registration",
        bullets: [
          "Type of Work: Computer Program",
          "Preregistration Number: PRE000012900",
          "Registration Date: October 14, 2022",
          "Original Project Name: CoSharks (now uCloud360)",
          "Development Start Date: August 4, 2022",
          "Owner: Inteligentic Solutions LLC & Jean Paul Zerpa"
        ]
      },
      {
        h: "What Is Protected",
        bullets: [
          "The uCloud360 platform name, logo, and brand identity.",
          "All source code, algorithms, and proprietary tools (time tracker, compound interest calculator, coin market tracker, economic calendar).",
          "The concept, architecture, and business model of the platform.",
          "All written content, designs, graphics, and user interface elements.",
          "The uCloud360 community structure and specialty channel system."
        ]
      },
      {
        h: "Permitted Use",
        body: "Users may access and use the platform as intended for personal, non-commercial purposes under an active subscription. No content may be reproduced, republished, modified, or distributed without express written permission from Inteligentic Solutions LLC."
      },
      {
        h: "Prohibited Actions",
        bullets: [
          "Copying, scraping, or reproducing any part of the platform without authorization.",
          "Reverse engineering, decompiling, or disassembling any proprietary code.",
          "Creating derivative works based on uCloud360's protected content.",
          "Using uCloud360's brand, name, or logo in a manner that implies endorsement without permission."
        ]
      },
      {
        h: "Legal Notice",
        body: "Any unauthorized reproduction, distribution, modification, or commercial use of uCloud360 is strictly prohibited and will be prosecuted to the fullest extent under applicable United States and international intellectual property law. Violators may be subject to civil and criminal penalties."
      },
      {
        h: "Reporting Infringement",
        body: "If you believe any content on uCloud360 infringes your intellectual property rights, please notify us at info@ucloud360.com with a detailed description of the claimed infringement."
      },
      {
        h: "Contact",
        body: "For intellectual property inquiries: info@ucloud360.com | Inteligentic Solutions LLC · Miami, FL, USA"
      }
    ]
  },
  es: {
    title: "Derechos de Autor y Propiedad Intelectual",
    updated: "Última actualización: Abril 2026",
    intro: "uCloud360 (anteriormente conocido como CoSharks) es una plataforma original protegida bajo las leyes de derechos de autor de los Estados Unidos. Todos los derechos relacionados con su concepto, arquitectura, diseño, desarrollo y contenido son propiedad exclusiva de Inteligentic Solutions LLC y Jean Paul Zerpa.",
    sections: [
      {
        h: "Registro de Derechos de Autor",
        bullets: [
          "Tipo de obra: Programa de computadora",
          "Número de prerregistro: PRE000012900",
          "Fecha de registro: 14 de octubre de 2022",
          "Nombre original del proyecto: CoSharks (ahora uCloud360)",
          "Fecha de inicio de desarrollo: 4 de agosto de 2022",
          "Propietario: Inteligentic Solutions LLC y Jean Paul Zerpa"
        ]
      },
      {
        h: "Qué Está Protegido",
        bullets: [
          "El nombre de plataforma uCloud360, logotipo e identidad de marca.",
          "Todo el código fuente, algoritmos y herramientas propias (time tracker, calculadora de interés compuesto, rastreador de mercado cripto, calendario económico).",
          "El concepto, arquitectura y modelo de negocio de la plataforma.",
          "Todo el contenido escrito, diseños, gráficos y elementos de interfaz de usuario.",
          "La estructura comunitaria y el sistema de canales de especialidad de uCloud360."
        ]
      },
      {
        h: "Uso Permitido",
        body: "Los usuarios pueden acceder y usar la plataforma para fines personales y no comerciales bajo una suscripción activa. Ningún contenido puede ser reproducido, republicado, modificado o distribuido sin autorización escrita expresa de Inteligentic Solutions LLC."
      },
      {
        h: "Acciones Prohibidas",
        bullets: [
          "Copiar, extraer o reproducir cualquier parte de la plataforma sin autorización.",
          "Realizar ingeniería inversa, descompilar o desensamblar cualquier código propietario.",
          "Crear obras derivadas basadas en el contenido protegido de uCloud360.",
          "Usar la marca, nombre o logotipo de uCloud360 de manera que implique respaldo sin permiso."
        ]
      },
      {
        h: "Aviso Legal",
        body: "Cualquier reproducción, distribución, modificación o uso comercial no autorizado de uCloud360 está estrictamente prohibido y será perseguido en la máxima medida permitida por las leyes de propiedad intelectual de los Estados Unidos e internacionales."
      },
      {
        h: "Reportar Infracciones",
        body: "Si crees que algún contenido en uCloud360 infringe tus derechos de propiedad intelectual, notifícanos a info@ucloud360.com con una descripción detallada de la supuesta infracción."
      },
      {
        h: "Contacto",
        body: "Para consultas de propiedad intelectual: info@ucloud360.com | Inteligentic Solutions LLC · Miami, FL, EE. UU."
      }
    ]
  }
}

export default function IntellectualPropertyPage() {
  const { lang } = useLang()
  const t = CONTENT[lang]
  return <LegalPage icon={<Copyright className="h-5 w-5" />} content={t} />
}
